import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Home/Home";

import "react-notifications/lib/notifications.css";
import { AuthProvider } from "./hooks/useAuth";
import { LoginModalProvider } from "./hooks/useLoginModal";

import BookingNew from "./BookingPage/BookingNew";
import ProtectedRoutes from "./ProtectedRoutes";
import { BookNowModalProvider } from "./hooks/useBookNowModal";
import { BookingDataProvider } from "./hooks/useBookingData";
import { BookingSelectedDetaisProvider } from "./hooks/useBookingSelectedDetails";
import { InternetConnectionProvider } from "./hooks/useInternetConnection";
import { LoadingProvider } from "./hooks/useLoading";
import { LoginStepProvider } from "./hooks/useLoginStep";
import { ManageBookingProvider } from "./hooks/useManageBookingData";
import { PageProvider } from "./hooks/usePage";
import { ProfileActiveProvider } from "./hooks/useProfileSection";
import PrivacyPolicy from "./Routes/PrivacyPolicy";
import RefundPolicy from "./Routes/RefundPolicy";
import TermsAndConditions from "./Routes/TermsAndConditions";
import ServiceLevelAgreement from "./Routes/ServiceLevelAgreement";
import OutstationCabTerms from "./Routes/OutstationCabTerms";
function App() {
  return (
    <>
      <AuthProvider>
        <InternetConnectionProvider>
          <PageProvider>
            <LoginModalProvider>
              <BookNowModalProvider>
                <LoadingProvider>
                  <LoginStepProvider>
                    <BookingSelectedDetaisProvider>
                      <BookingDataProvider>
                        <ManageBookingProvider>
                          <ProfileActiveProvider>
                            <Routes>
                              <Route path="/" element={<Home></Home>} />

                              <Route path="/privacy-policy" element={<PrivacyPolicy Header={"Yes"}></PrivacyPolicy>} />
                              <Route path="/refund-policy" element={<RefundPolicy Header={"Yes"}></RefundPolicy>} />
                              <Route path="/service-agreement" element={<ServiceLevelAgreement Header={"Yes"}></ServiceLevelAgreement>} />
                              <Route path="/terms-and-conditions" element={<TermsAndConditions Header={"Yes"}></TermsAndConditions>} />
                              <Route path="/other-terms" element={<OutstationCabTerms></OutstationCabTerms>} />

                              {/* <Route
                              path="/forgot-password"
                              element={<ForgotPassword></ForgotPassword>}
                            />
                            <Route path="/policy" element={<Policy />} /> */}
                              <Route element={<ProtectedRoutes />}>
                                <Route
                                  path="/booking"
                                  element={<BookingNew></BookingNew>}
                                />
                              </Route>
                              <Route path="*" element={<Navigate to="/" />} />
                            </Routes>
                          </ProfileActiveProvider>
                        </ManageBookingProvider>
                      </BookingDataProvider>
                    </BookingSelectedDetaisProvider>
                  </LoginStepProvider>
                </LoadingProvider>
              </BookNowModalProvider>
            </LoginModalProvider>
          </PageProvider>
        </InternetConnectionProvider>
      </AuthProvider>
    </>
  );
}

export default App;
